/**
 * The containers card's head, one row: "Containers" + count + tally (and,
 * 27/10/2026, All on · All off) on the left; on the right the open campaign's master config control (when a
 * campaign is open) and Add container — off, with the reason, while the
 * campaign has no master config.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC, ReactNode } from 'react';
import { Layers, Plus } from 'lucide-react';

import { Button, HintDot } from '@/components/ui';

interface Props {
  scoped: boolean;
  shown: number;
  enabled: number;
  /** The open campaign's master config control. */
  extra?: ReactNode;
  /** Why Add container is off right now; null = available. */
  addBlocked: string | null;
  onAdd: () => void;
  /** 18/10/2026 — the chip that lists only the containers with drops outside the window. */
  outside?: ReactNode;
  /** Why Add route test is off; null = available. Absent = no button. */
  routeTestBlocked?: string | null;
  onAddRouteTest?: () => void;
  /** 27/10/2026 — All on · All off, beside the tally. */
  switchAll?: ReactNode;
}

export const BoardCardHeader: FC<Props> = ({ scoped, shown, enabled, extra, addBlocked, onAdd, outside, routeTestBlocked, onAddRouteTest, switchAll }) => (
  <div className="flex flex-wrap items-center gap-x-3 gap-y-2 border-b border-border/60 px-5 py-3">
    <h2 className="flex items-center gap-2 text-sm font-semibold">
      <Layers className="h-4 w-4 text-muted-foreground" /> Containers
      <span className="rounded-full bg-muted px-2 py-0.5 font-mono text-[11px] font-medium tabular-nums text-muted-foreground">{shown}</span>
    </h2>
    <span className="flex items-center gap-1 text-xs text-muted-foreground">
      {enabled} enabled · {shown - enabled} disabled
      {scoped ? (
        <HintDot label="Only this campaign's containers are listed. They still run in the country's execution order, so their times include the other campaigns' containers that come first. Dragging reorders them among themselves only." />
      ) : null}
    </span>
    {switchAll}
    {outside}
    <div className="ml-auto flex flex-wrap items-center gap-2">
      {extra}
      {onAddRouteTest ? (
        <span title={routeTestBlocked ?? undefined}>
          <Button size="sm" variant="outline" onClick={onAddRouteTest} disabled={routeTestBlocked !== null}>
            <Plus className="mr-1 h-3.5 w-3.5" /> Add route test
          </Button>
        </span>
      ) : null}
      <span title={addBlocked ?? undefined}>
        <Button size="sm" onClick={onAdd} disabled={addBlocked !== null}>
          <Plus className="mr-1 h-3.5 w-3.5" /> Add container
        </Button>
      </span>
    </div>
  </div>
);
